import React from "react"
import "./banner.sass"
import Button from "../../components/button"
import { applyTypes } from "../../components/forms/form"
import { defaultIntl } from "../../utils"
import { MERCHANT } from "../../../config"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="partner-banner">
      <div className="banner--body">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column">
              <div className="text-content">
                <h1>{intl.formatMessage({ id: "partner.banner.title" })}</h1>
                <p>{intl.formatMessage({ id: "partner.banner.desc" })}</p>
                <Button to={`${MERCHANT}/${intl.locale}/`}>{intl.formatMessage({ id: "partner.banner.btn" })}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
